import api from "../../api/index";

const updatepassword = `${process.env.VUE_APP_BASE_URI}/auth/user/password`;
const updateChartSettings = `${process.env.VUE_APP_BASE_URI}/auth/company/chartsettings`;

const getDefaultState = () => {
  return {
    status: "",
  };
};

const state = getDefaultState();

const actions = {
  async updatePassword({ commit }, updatedpassword) {
    commit("updatepassword_request");
    const res = await api.patch(updatepassword, updatedpassword);
    if (res.data.status === "success") {
      commit("updatepassword_success");
    }
    return res;
  },
  async handleChartUpdate({ commit }, updatedData) {
    commit("update_chart_request");
    const response = await api.patch(updateChartSettings, updatedData);
    console.log(response, "response");
    if (response.data.success) {
      commit("update_chart_success");
    }
    return response;
  },

  async resetProfileState({ commit }) {
    await commit("resetprofilestate_success");
  },
};

const mutations = {
  update_chart_request: (state) => (state.status = "loading"),
  update_chart_success: (state) => (state.status = "success"),

  updatepassword_request: (state) => (state.status = "loading"),
  updatepassword_success: (state) => (state.status = "success"),
  resetprofilestate_success: (state) => Object.assign(state, getDefaultState()),
};

export default {
  state,
  actions,
  mutations,
};
